var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingGroupEmojis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 797.221,
    height: 136.858,
    viewBox: "0 0 797.221 136.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(-835.688 -547.67)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Very_Bad",
    "data-name": "Very Bad",
    transform: "translate(835.688 672.528)",
    fill: "#d92028",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Very Bad")), /*#__PURE__*/React.createElement("text", {
    id: "Bad",
    transform: "translate(1006.491 672.528)",
    fill: "#f0585f",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bad")), /*#__PURE__*/React.createElement("text", {
    id: "Good",
    transform: "translate(1273.756 672.528)",
    fill: "#ffcd3a",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Good")), /*#__PURE__*/React.createElement("text", {
    id: "Okay",
    transform: "translate(1137.927 672.528)",
    fill: "#f69138",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Okay")), /*#__PURE__*/React.createElement("text", {
    id: "Great",
    transform: "translate(1406.844 672.528)",
    fill: "#93cc89",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Great")), /*#__PURE__*/React.createElement("text", {
    id: "Excellent",
    transform: "translate(1524.908 672.528)",
    fill: "#59b952",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Excellent")), /*#__PURE__*/React.createElement("g", {
    id: "Artboard_88",
    "data-name": "Artboard 88",
    transform: "translate(846.763 547.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(692.949 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(23.285 39.404) rotate(-80.78)",
    fill: "#5bba54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(51.755 34.626) rotate(-45)",
    fill: "#5bba54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    d: "M557.6,533.19a44.18,44.18,0,1,0,44.18,44.18A44.229,44.229,0,0,0,557.6,533.19Zm39.225,44.18A39.225,39.225,0,1,1,557.6,538.145,39.27,39.27,0,0,1,596.824,577.37Z",
    transform: "translate(-513.42 -533.19)",
    fill: "#59b952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    "data-name": "Path 4130",
    d: "M654.561,870.568a23.461,23.461,0,0,0,46.922,0V868.09H654.56v2.478Zm41.8,2.478a18.51,18.51,0,0,1-36.683,0h36.684Z",
    transform: "translate(-633.845 -818.936)",
    fill: "#59b952"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(553.996 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(23.144 39.2) rotate(-79.1)",
    fill: "#93cc89"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(51.756 34.625) rotate(-45)",
    fill: "#93cc89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    d: "M1422.931,533.19a44.18,44.18,0,1,0,44.18,44.18A44.231,44.231,0,0,0,1422.931,533.19Zm39.225,44.18a39.225,39.225,0,1,1-39.225-39.225A39.27,39.27,0,0,1,1462.156,577.37Z",
    transform: "translate(-1378.75 -533.19)",
    fill: "#93cc89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    d: "M1546.336,876.96a2.482,2.482,0,0,0-3.269,1.258,24.814,24.814,0,0,1-45.352,0,2.477,2.477,0,0,0-4.526,2.014,29.77,29.77,0,0,0,54.408,0,2.477,2.477,0,0,0-1.259-3.27Z",
    transform: "translate(-1476.21 -826.322)",
    fill: "#93cc89"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(138.953 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(23.31 39.407) rotate(-80.78)",
    fill: "#f0585f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(52.945 38.906) rotate(-76.72)",
    fill: "#f0585f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    d: "M4037.64,533.19a44.18,44.18,0,1,0,44.179,44.18A44.229,44.229,0,0,0,4037.64,533.19Zm39.225,44.18a39.225,39.225,0,1,1-39.225-39.225A39.27,39.27,0,0,1,4076.865,577.37Z",
    transform: "translate(-3993.461 -533.19)",
    fill: "#f0585f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    d: "M4135.083,838.48a29.8,29.8,0,0,0-27.2,17.68,2.478,2.478,0,0,0,4.528,2.014,24.814,24.814,0,0,1,45.353,0,2.478,2.478,0,0,0,4.528-2.014A29.8,29.8,0,0,0,4135.083,838.48Z",
    transform: "translate(-4090.904 -793.672)",
    fill: "#f0585f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(21.744 34.624) rotate(-45)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(53.152 39.198) rotate(-79.1)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4135",
    "data-name": "Path 4135",
    d: "M4932.891,533.19a44.18,44.18,0,1,0,44.181,44.18,44.23,44.23,0,0,0-44.181-44.18Zm39.225,44.18a39.226,39.226,0,1,1-39.225-39.225,39.27,39.27,0,0,1,39.225,39.225Z",
    transform: "translate(-4888.71 -533.19)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    d: "M5053.342,838.472a23.488,23.488,0,0,0-23.462,23.461,2.478,2.478,0,0,0,3.71,2.149,39.774,39.774,0,0,1,19.75-5.269h.2a39.78,39.78,0,0,1,19.555,5.266,2.477,2.477,0,0,0,3.711-2.147,23.488,23.488,0,0,0-23.46-23.461Zm18.008,19.189a44.345,44.345,0,0,0-17.792-3.8h-.219a44.3,44.3,0,0,0-18.007,3.8,18.513,18.513,0,0,1,36.016,0Z",
    transform: "translate(-5009.16 -793.664)",
    fill: "#d92028"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    d: "M5049.109,691.144a1.71,1.71,0,0,1-.481-.069l-12.478-3.583a1.742,1.742,0,1,1,.959-3.349l12.479,3.583a1.743,1.743,0,0,1-.479,3.418Z",
    transform: "translate(-5013.431 -661.929)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    d: "M5244.3,691.129a1.743,1.743,0,0,1-.478-3.418l12.478-3.583a1.742,1.742,0,0,1,.959,3.349l-12.479,3.583A1.713,1.713,0,0,1,5244.3,691.129Z",
    transform: "translate(-5190.622 -661.914)",
    fill: "#d92028"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(276.998 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(22.908 38.811) rotate(-75.75)",
    fill: "#f69138"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(52.953 38.906) rotate(-76.72)",
    fill: "#f69138"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4139",
    "data-name": "Path 4139",
    d: "M3182.771,533.19a44.18,44.18,0,1,0,44.18,44.18A44.231,44.231,0,0,0,3182.771,533.19ZM3222,577.37a39.226,39.226,0,1,1-39.225-39.225A39.27,39.27,0,0,1,3222,577.37Z",
    transform: "translate(-3138.59 -533.19)",
    fill: "#f69138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    "data-name": "Path 4140",
    d: "M3325.142,869.906a57.923,57.923,0,0,0-43.839,0,2.477,2.477,0,0,0,.937,4.77,2.414,2.414,0,0,0,.935-.185,53.679,53.679,0,0,1,21.459-3.922,52.855,52.855,0,0,1,18.635,3.922,2.45,2.45,0,0,0,.936.186,2.494,2.494,0,0,0,.96-.2,2.477,2.477,0,0,0-.022-4.576Z",
    transform: "translate(-3259.042 -816.809)",
    fill: "#f69138"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(415.951)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "matrix(0.217, -0.976, 0.976, 0.217, 23.043, 39.021)",
    fill: "#ffcd3a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "matrix(0.972, -0.234, 0.234, 0.972, 52.957, 30.389)",
    fill: "#ffcd3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    "data-name": "Path 4141",
    d: "M2304.262,533.19a44.18,44.18,0,1,0,44.18,44.18A44.231,44.231,0,0,0,2304.262,533.19Zm0,83.406a39.225,39.225,0,1,1,39.225-39.226A39.27,39.27,0,0,1,2304.262,616.6Z",
    transform: "translate(-2260.08 -533.19)",
    fill: "#ffcd3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    "data-name": "Path 4142",
    d: "M2445.7,893.71h-41.968a2.478,2.478,0,1,0,0,4.955H2445.7a2.478,2.478,0,0,0,0-4.955Z",
    transform: "translate(-2380.531 -840.796)",
    fill: "#ffcd3a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGroupEmojis);
export default __webpack_public_path__ + "static/media/RatingGroupEmojis.480b3b90ad7e22a621ff1f828e708d1a.svg";
export { ForwardRef as ReactComponent };